// extracted by mini-css-extract-plugin
module.exports = {"reason":"Reason_reason__1Q5gm"};